import { render, staticRenderFns } from "./AdminUnternehmen.vue?vue&type=template&id=d0311b0e&"
import script from "./AdminUnternehmen.vue?vue&type=script&lang=ts&"
export * from "./AdminUnternehmen.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUnternehmen.vue?vue&type=style&index=0&lang=scss&scopred=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports